import React from 'react';
import { Input } from 'antd';
import type { WidgetProps } from '../registry';

export const SimpleTelWidget: React.FC<WidgetProps> = ({
  widget,
  onChange,
  onBlur,
  error,
  warning,
}) => {
  return (
    <div className="rul-widget-field">
      {widget.label && (
        <label className="rul-widget-field-label">
          {widget.label}
          {widget.required && <span className="required">*</span>}
        </label>
      )}
      <Input
        type="tel"
        value={widget.value || ''}
        placeholder={widget.placeholder}
        onChange={(e) => onChange?.(widget.name, e.target.value)}
        onBlur={(e) => onBlur?.(widget.name, e.target.value)}
        status={error ? 'error' : warning ? 'warning' : ''}
        size="large"
      />
      {error && <div className="rul-widget-error">{error}</div>}
      {warning && !error && <div className="rul-widget-warning">{warning}</div>}
    </div>
  );
};
